export const pushToDataLayer = (eventData = {}) => {
  // Check if we are in a browser environment
  if (typeof window !== 'undefined') {
    // Ensure dataLayer is an array before pushing to it
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
};

export const pushToDataLayerEvent = (eventData = {}) => {
  // Check if we are in a browser environment
  if (typeof window !== 'undefined') {
    // Push the event with a nested MCP object
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      MCP: {
        PageType: eventData.pageType, // Default value in case pageType is undefined
      },
    });
  }
};

export const trackTrue4Events = ({
  eventName,
  eventCategoryName,
  buttonClicked, // eg: "Clear Text"
  searchTerm, // eg: "ron" | "EV"
  brandName,
  variantName,
}) => {
  // Check if we are in a browser environment
  if (typeof window !== 'undefined') {
    // Ensure dataLayer is an array before pushing to it
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      eventCategory: eventCategoryName,
      eventAction: buttonClicked || 'NA',
      eventLabel: searchTerm || 'NA',
      BrandName: brandName || 'NA',
      VariantName: variantName || 'NA',
    });
  }
};
